import React, { Component } from "react";

// import {
//         Button,

//     FormGroup,
//     Label

// } from 'reactstrap';

class QuestionTable extends Component {
  // constructor(props) {
  //     super(props);
  // }
  render() {
    console.log("this.props.stateFillData", this.props.stateFillData);
    var cusorPointer = { cursor: "pointer" };
    return (
      <table className="table">
        <thead>
          <tr>
            <th> Id </th>
            <th> Question Text </th>
            <th> Help Text </th>
            <th> Edit </th>
          </tr>
        </thead>

        <tbody>
          {this.props.stateFillData.map((item, i) => (
            <tr key={item.id}>
              <th scope="row"> {item.id} </th>
              <td>{item.question_text} </td>
              <td> {item.question_info} </td>
              <td>
                <div>
                  <button className="btn btn-sm btn-primary" style={cusorPointer} value={item.id} onClick={this.props.toggleModal}>
                    <i className="fa fa-pencil-square-o"></i>&nbsp; Edit{" "}
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default QuestionTable;



// WEBPACK FOOTER //
// ./src/views/questions/question_table.js